import React, { FC, useState } from 'react'
import { useTypedSelector } from 'src/redux/root-reducer'
import { Plan } from 'src/redux/types/planTypes'
import Amount from './Amount/Amount'
import BeneficiaryAccount from './Beneficiary/BeneficiaryAccount'
import {
  CloseWithdrawModalBtn,
  WithdrawComponent,
  WithdrawModalBackground,
  WithdrawModalContainer,
  WithdrawWrapper,
} from './style'

interface withdrawalProps {
  showWithdrawalModal: boolean
  setShowWithdrawalModal: (bol: boolean) => void
  plan: Plan
  type: 'investment' | 'plan'
}

const WithdrawalModal: FC<withdrawalProps> = ({
  showWithdrawalModal,
  setShowWithdrawalModal,
  plan,
  type = 'plan',
}: any) => {
  const closeModal = () => {
    setShowWithdrawalModal(false)
  }

  const [fullWithdrawal, setFullWithdrawal] = useState(true)

  const [amount, setAmount] = useState('')

  // const toggleFullWithdrawal = () => {
  const toggleFullWithdrawal = (val?: boolean) => {
    setFullWithdrawal(!fullWithdrawal)
  }

  const onEnterAmount = (amount: string) => setAmount(amount)

  const user_banks = useTypedSelector(
    (state) => state.banksResult.getMyBanks.bank_details
  )

  const [bank, setBank] = useState({})

  return (
    <WithdrawModalContainer>
      {showWithdrawalModal ? (
        <WithdrawModalBackground>
          <WithdrawWrapper>
            <CloseWithdrawModalBtn onClick={closeModal} />
            <WithdrawComponent>
              <Amount
                fullWithdrawal={fullWithdrawal}
                toggleFullWithdrawal={toggleFullWithdrawal}
                amount={amount}
                balance={plan?.balance || 0}
                onEnterAmount={onEnterAmount}
              />
              <BeneficiaryAccount
                userBanks={user_banks}
                bank={bank}
                setBank={setBank}
                amount={amount}
                fullWithdrawal={fullWithdrawal}
                sourceId={plan?.id}
                balance={plan?.balance || 0}
              />
            </WithdrawComponent>
          </WithdrawWrapper>
        </WithdrawModalBackground>
      ) : null}
    </WithdrawModalContainer>
  )
}

export default WithdrawalModal
